module.exports = __webpack_public_path__ + "static/new-hero-8c640ec721ed0de32bdbdcb88ba96c1c.jpg";